import React from 'react';
import ReactDOM from 'react-dom/client';

function About(){
    return (
            <div>
                <div className='about-head'>
                    About Us
                </div>
                <div className='who-we-are'>
                    Who am I?
                <p> I am currently pursuing B.tech in Computer Science and Information technology. This project is developed by us to help the students who are new in the field of competitive programming. We aim to provide best possible resources in one place for all the keen learners of programming.</p>
                
                <div className='our-team'>
                        College
                    <p> MJP Rohilkhand University</p>
                    <p> Bareilly, Uttar Pradesh</p>
                    {/* <p> Sanjay Gangwar (B.Tech CSIT 3rd Year)</p>
                    <p> Vaibhav Giri (B.Tech CSIT 3rd Year)</p> */}
                </div>

                <div className='vision'>
                     Our vision
                    <p>
                        In many tier-3 colleges, the students who want to learn coding face many difficulties. They lack resources, guides and coding community.
                        Our effort is to provide useful roadmap and make a helpful community. 
                    </p>
                </div>
                
                </div>
                
            </div>

    )
}
export default About;